import accounting from 'accounting';

export const formatMoney = (number) => {
	const value = parseInt(number, 10);

	return accounting.formatMoney(value, {
		symbol: 'Rp',
		decimal: ',',
		thousand: '.',
		precision: 0,
		format: '%s%v'
	});
};

export const formatNumber = (number) => {
	const value = parseInt(number, 10);

	return accounting.formatMoney(value, {
		symbol: '',
		decimal: ',',
		thousand: '.',
		precision: 0,
		format: '%s%v'
	});
}



// WEBPACK FOOTER //
// ./src/utils/formatMoney.js